import React, { useEffect, useState } from 'react'
import './index.css'
import { Button, Card, Col, Flex, Form, Row, Typography } from 'antd'
import { motion } from 'framer-motion'
import { MyInput, MySelect } from '../../PageComponents'
import { Link, useNavigate } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { actionsApi } from '../../../shared/redux/actionsApi';
import { services } from '../../../shared/Lookup'
import { apiCalls } from '../../../shared/Apis'

const { Text, Title } = Typography
const MainSection = () => {

    const { form  } = Form.useForm()
    const dispatch = useDispatch();
    const [searchName, setSearchName] = useState('');
    const [searchLocation, setSearchLocation] = useState('');
    const navigate = useNavigate();
    const [ servicelookup, setServiceLookup ] = useState([])

    const searchHandler = () => {
        // Redirect to findpro with search parameters
        navigate(`/findpro?name=${encodeURIComponent(searchName)}&location=${encodeURIComponent(searchLocation)}`);
    };

    useEffect(()=>{
        getService()
    },[])

    const getService = async () => {
        let result= await apiCalls?.serviceApi?.getService()
        if(result)
        setServiceLookup(result)
    }
  return (
    <div className='main-section py-3'>
        <div className='container'>
            <Row gutter={[24,24]} justify={'center'}>
                <Col lg={{span: 18}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <Flex vertical justify='center' className='position-relative' gap={30} >
                        <motion.div
                            initial={{ opacity: 0}}
                            whileInView={{
                                opacity: 1
                            }}
                            transition={{ duration: 2, ease: 'easeInOut' }}
                            viewport={{once: true}}
                            className='position-relative'
                        >
                            <Title level={1} className='font-main text-white'>
                                Book An <br /> Appointment
                            </Title>
                            <Title level={2} className='m-0 text-white'>
                                Find a pro you’ll love
                            </Title>
                        </motion.div>
                    </Flex>
                </Col>
                <Col span={24}>
                    <Card className='shadow-c rounded mt-3'>
                        <Form
                            layout='vertical'
                            form={form}

                        >
                            <Row gutter={[24,24]} align={'middle'}>
                                <Col lg={{span: 10}} md={{span:9}} sm={{span: 24}} xs={{span: 24}}>
                                    <MySelect
                                        label='Services'
                                        name='services'
                                        message='Please enter services'
                                        options={servicelookup}
                                    />
                                </Col>
                                <Col lg={{span: 10}} md={{span:9}} sm={{span: 24}} xs={{span: 24}}>
                                    <MyInput 
                                        label='Location'
                                        name='location'
                                        placeholder='Town'
                                        suffix={<img src='/assets/icons/location.png' width={16} />}
                                        value={searchLocation}
                                        onChange={(e)=>setSearchLocation(e.target.value)}
                                    />
                                </Col>
                                <Col lg={{span: 4}} md={{span:6}} sm={{span: 24}} xs={{span: 24}}>
                                    <Button className='btn mt-3' onClick={searchHandler}>Search jobs</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
                {/* <Col>
                    <Title level={3} className=''>
                        Search 142,659 new jobs - 2,469 added in the last 24 hours
                    </Title>
                </Col> */}
            </Row>
        </div>
    </div>
  )
}

export {MainSection}